// modals/EditPublicationModal.js
import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const EditPublicationModal = ({ show, onHide, onUpdate, newPub, handleChange, handleFileChange }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Modifier la Publication</Modal.Title>
      </Modal.Header>
      <Form onSubmit={onUpdate}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Titre *</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={newPub.title}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Contenu *</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="content"
              value={newPub.content}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Type</Form.Label>
            <Form.Select name="type" value={newPub.type} onChange={handleChange}>
              <option value="banner">Bannière</option>
              <option value="promo">Promotion</option>
              <option value="news">Actualité</option>
              <option value="featured-product">Produit mis en avant</option>
              <option value="flash-sale">Flash Sale</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Lien cible</Form.Label>
            <Form.Control
              type="url"
              name="linkUrl"
              value={newPub.linkUrl}
              onChange={handleChange}
              placeholder="https://yoursite.com/..."
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date de début *</Form.Label>
            <Form.Control
              type="date"
              name="startDate"
              value={newPub.startDate}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date de fin *</Form.Label>
            <Form.Control
              type="date"
              name="endDate"
              value={newPub.endDate}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Image (changer si besoin)</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
            <small className="text-muted">Laissez vide pour conserver l'image actuelle</small>
            {
              newPub && newPub.imageUrl && (
                <div className="mb-3">
                  <Form.Label>Image actuelle :</Form.Label>
                  <div>
                    <img src={newPub.imageUrl} alt="Current Publication" className="img-fluid rounded" style={{ maxHeight: '200px' }} />
                  </div>
                </div>
              )
            }
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Annuler
          </Button>
          <Button variant="success" type="submit">
            Enregistrer les modifications
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditPublicationModal;